import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/cn';
import type { Difficulty } from '@/types';

const badgeClass: Record<Difficulty, string> = {
  easy: 'badge-easy',
  medium: 'badge-medium',
  hard: 'badge-hard',
};

export function DifficultyBadge({ difficulty, className }: { difficulty: Difficulty; className?: string }) {
  const { t } = useTranslation();
  return (
    <span className={cn('inline-flex items-center rounded px-2 py-0.5 text-xs font-semibold', badgeClass[difficulty], className)}>
      {t(`difficulty.${difficulty}`)}
    </span>
  );
}
